// extracted by mini-css-extract-plugin
export default {"productGallery":"sJ-z","inQuickShop":"tJ-z"};